var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"btn btn-secondary add-to-cart btn-sm",attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.rePrintRequest(_vm.item)}}},[(_vm.icon)?_c('i',{staticClass:"fa fa-print"}):_vm._e(),_vm._v(" \n  Reprint Request")])
}
var staticRenderFns = []

export { render, staticRenderFns }